import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { useState, useEffect } from "react";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
const useWindowResize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window?.innerWidth,
    height: window?.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window?.innerWidth,
        height: window?.innerHeight,
      });
    };
    // Add event listener for window resize
    window.addEventListener("resize", handleResize);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowSize;
};
export default useWindowResize;

export function convertDate(inputDate) {
  // Create a new Date object from the input string
  const parsedDate = new Date(inputDate);

  // Extract year, month, and day from the parsed date
  const year = parsedDate.getFullYear().toString().slice(-2); // Get last 2 digits of the year
  const month = ("0" + (parsedDate.getMonth() + 1)).slice(-2); // Months are zero-based
  const day = ("0" + parsedDate.getDate()).slice(-2);

  // Construct the desired output format
  const outputDate = `${year}/${month}/${day}`;

  return outputDate;
}

export const toCamelCase = (inputString) => {
  return inputString
    .toLowerCase()
    .replace(/\b\w/g, (match) => match.toUpperCase())
    .replace(/\s+/g, "")
    .replace(/^(.)/, (match) => match.toLowerCase())
    .replace(/s$/, "");
};

// Function to convert "newOrder" to "New Orders"
export const convertKeysToTitleCase = (obj) => {
  const newObj = {};
  for (const key in obj) {
    const newKey = key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
    newObj[newKey] = obj[key];
  }
  return newObj;
};
export function formatDate(date) {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return new Date(date).toLocaleDateString("en-US", options);
}

export const getMonthName = (monthIndex) => {
  if (monthIndex < 1 || monthIndex > 12 || isNaN(monthIndex)) {
    return "Invalid Month";
  }
  const date = new Date();
  date.setMonth(monthIndex - 1);
  return date.toLocaleString("default", { month: "short" });
};
